module.exports = __webpack_public_path__ + "img/myCollection.92d17e61.png";